import { graphql } from "@/gql";

export const markThreadAsReadMutation = graphql(`
  mutation MarkThreadAsRead($thread_id: ID!) {
    markThreadAsRead(thread_id: $thread_id) {
      id
    }
  }
`);

export const markThreadAsUnreadMutation = graphql(`
  mutation MarkThreadAsUnread($thread_id: ID!) {
    markThreadAsUnread(thread_id: $thread_id) {
      id
    }
  }
`);

export const createThreadMutation = graphql(`
  mutation CreateThread($input: CreateThreadInput!) {
    createThread(input: $input) {
      id
    }
  }
`);

export const createSupplierWorkOrderThreadMutation = graphql(`
  mutation CreateSupplierWorkOrderThread($work_order_id: ID!) {
    createSupplierWorkOrderThread(work_order_id: $work_order_id) {
      id
    }
  }
`);

export const setThreadClosedMutation = graphql(`
  mutation SetThreadClosed($id: ID!, $closed: Boolean!) {
    setThreadClosed(id: $id, closed: $closed) {
      id
      closed
    }
  }
`);

export const setThreadNotificationsMutation = graphql(`
  mutation SetThreadNotifications($thread_id: ID!, $enabled: Boolean!) {
    setThreadNotifications(thread_id: $thread_id, enabled: $enabled) {
      id
      subscription {
        id
        notifications_enabled
      }
    }
  }
`);
